// Plain-English translations of internal machine labels. PRESENTATION ONLY — no new logic,
// no scores, no confidence numbers. Raw machine values stay in "Technical details".

export const TONE = {
  positive: "text-emerald-400 bg-emerald-400/10 border-emerald-400/20",
  info: "text-sky-400 bg-sky-400/10 border-sky-400/20",
  expansion: "text-violet-400 bg-violet-400/10 border-violet-400/20",
  review: "text-amber-400 bg-amber-400/10 border-amber-400/20",
  neutral: "text-zinc-300 bg-zinc-800/60 border-zinc-700",
  eligible: "text-zinc-100 bg-zinc-800/70 border-zinc-600",
  error: "text-rose-400 bg-rose-400/10 border-rose-400/20",
};

// Movement of the whole product IDEA (concept level)
export const MOVEMENT = {
  ONE_ASIN_CLIMBING: { label: "One listing gaining rank", tone: "positive",
    info: "One Amazon listing improved its New Releases position." },
  MULTIPLE_ASINS_CLIMBING: { label: "Several listings gaining rank", tone: "positive",
    info: "More than one independent Amazon listing improved its New Releases position." },
  NEW_ASINS_APPEARING: { label: "New listings appearing", tone: "info",
    info: "New Amazon listings for this product idea appeared during the tracking period." },
  CONCEPT_EXPANSION: { label: "More listings appearing", tone: "expansion",
    info: "The number of independent Amazon listings associated with this product idea increased over time." },
  STABLE: { label: "Holding steady", tone: "neutral",
    info: "No notable rank movement or new listings during the tracking period." },
};

// Eligibility (NOT traction). "Enough history" only means we can analyze — it does not mean rising.
export const STATUS = {
  EARLY_TRAJECTORY_ELIGIBLE: { label: "Enough history to analyze", tone: "eligible", icon: "check",
    info: "We have enough observations across enough days to look at movement reliably. This does NOT mean the product is rising." },
  INSUFFICIENT_HISTORY: { label: "Still collecting data", tone: "neutral", icon: "clock",
    info: "Needs at least 5 observations across 7 days before we analyze movement." },
};

export function evidenceInfo(grade) {
  if (grade === "A") return { label: "Strong", detail: "", tone: "positive" };
  if (grade === "B") return { label: "Moderate", detail: "Amazon + another source", tone: "info" };
  return { label: "Limited", detail: "Amazon only", tone: "review" }; // C / D
}

export const EVIDENCE_TOOLTIP =
  "Evidence strength measures how much independent, reliable data supports this product. It is different from product movement.";
export const GROUPING_TOOLTIP =
  "Breakout Radar may have grouped products that are similar but not truly the same opportunity. Review the individual listings before trusting the combined trajectory.";
export const CENSORED_TOOLTIP =
  "This does not mean the product declined. It means the listing was not visible within the Top 30 positions we collected that day.";
export const HISTORY_TOOLTIP =
  "A product needs at least 5 observations across at least 7 days before Breakout Radar analyses its movement.";

export function conceptName(cid) {
  if (!cid) return "";
  const n = cid.replace("concept:", "").replace(/_/g, " ");
  return n.charAt(0).toUpperCase() + n.slice(1);
}

export function shortTitle(t, max = 90) {
  if (!t) return "";
  return t.length > max ? t.slice(0, max).trim() + "…" : t;
}

// Current-signal stage → plain label + tone + Products filter param. PRESENTATION ONLY.
export const SIGNAL_META = {
  HOLDING_STEADY: { label: "Holding steady", tone: "neutral", param: null,
    cls: "text-zinc-400 bg-zinc-800/60 border-zinc-700", dot: "bg-zinc-500" },
  WATCH: { label: "Watch", tone: "info", param: "watch",
    cls: "text-sky-300 bg-sky-400/10 border-sky-400/25", dot: "bg-sky-400" },
  INTERESTING: { label: "Interesting", tone: "expansion", param: "interesting",
    cls: "text-violet-300 bg-violet-400/10 border-violet-400/25", dot: "bg-violet-400" },
  STRONG_AMAZON_SIGNAL: { label: "Strong Amazon Signal", tone: "positive", param: "strong",
    cls: "text-emerald-300 bg-emerald-400/10 border-emerald-400/25", dot: "bg-emerald-400" },
  INVESTIGATE: { label: "Investigate", tone: "positive", param: "investigate",
    cls: "text-emerald-200 bg-emerald-500/15 border-emerald-400/40", dot: "bg-emerald-400" },
  CROSS_SOURCE_CANDIDATE: { label: "Cross-source candidate", tone: "error", param: "cross-source",
    cls: "text-rose-200 bg-rose-500/15 border-rose-400/45", dot: "bg-rose-400" },
};

// Sort priority for the master candidate list (most actionable first).
export const SIGNAL_PRIORITY = {
  CROSS_SOURCE_CANDIDATE: 0, INVESTIGATE: 1, STRONG_AMAZON_SIGNAL: 2,
  INTERESTING: 3, WATCH: 4, HOLDING_STEADY: 5,
};

// filter key (URL ?signal=) → stage
export const FILTER_TO_STAGE = {
  watch: "WATCH", interesting: "INTERESTING", strong: "STRONG_AMAZON_SIGNAL",
  investigate: "INVESTIGATE", "cross-source": "CROSS_SOURCE_CANDIDATE",
};
